import { BackButton } from "@publicPortal/components/BackButton/BackButton";
import Board from "@publicPortal/components/board/Board";
import ResponsiveAppBar from "@publicPortal/components/responsiveAppBar/ResponsiveAppBar";
import { RecordDetailsTabNames } from "@publicPortal/utils/enums";
import React, { useEffect, useState } from "react";
import { atom, useRecoilValue } from "recoil";
import BuildingRegulationTabs, { BuildingRegulationTabNames } from "./BuildingRegulationTabs";
import BuildingRegulationsService from "@publicPortal/services/BuildingRegulationsService";
import { useParams } from "react-router-dom";
import BrSummaryTabContent from "./tabContent/BrSummaryTabContent";
import BrDocumentsTabContent from "./tabContent/BrDocumentsTabContent";
import { IBuildingRegulationsDetails } from "@shared/publicportal/contracts/IBuildingRegulationsDetails";

export const buildingRegulationDetailsState = atom({
    key: "buildingRegulationDetailsState",
    default: {} as { [x: string]: RecordDetailsTabNames },
});
const service = new BuildingRegulationsService();

const BuildingRegulation = () => {
    const { id } = useParams();
    const [bcApp, setBcApp] = useState<IBuildingRegulationsDetails | null>(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        service.getBcAppById(Number(id)).then((response) => {
            if (!response) {
                setLoading(false);
                return;
            }
            setBcApp(response);
            setLoading(false);
        });
    }, [id]);

    return (
        <>
            <ResponsiveAppBar />
            <Board size="big" headerText={"Building Regulation " + (bcApp?.name || "not found")} loadingHeaderText={loading}>
                <BackButton />
                <BuildingRegulationTabs recordId={bcApp?.id} />
                <BuildingRegulationTabContent bcApp={bcApp} loading={loading} />
            </Board>
        </>
    );
};

const BuildingRegulationTabContent: React.FC<{ bcApp: IBuildingRegulationsDetails | null; loading: boolean }> = ({ bcApp, loading }) => {
    const currentTab = useRecoilValue(buildingRegulationDetailsState);
    if (!bcApp) {
        return null;
    }
    switch (currentTab[bcApp?.id ?? 0] || BuildingRegulationTabNames.Summary) {
        case BuildingRegulationTabNames.Summary:
            return <BrSummaryTabContent bcApp={bcApp} loading={loading} />;
        case BuildingRegulationTabNames.Documents:
            return <BrDocumentsTabContent appId={bcApp.id} />;
        default:
            return null;
    }
};

export default BuildingRegulation;
